import Tags from '@/componentsDS/Tags/Tags';

const StatusLabel = ({ text, itemStatus }) => {

	const status = {
		pending: "PENDING",
		pendingApproval: "PENDING_APPROVAL",
		approve: "APPROVED",
		reject: "REJECTED",
		signDsa: "SIGN_DSA",
		requestForInfo:"REQUEST_FOR_INFO",
		dsaRequested: "DSA_REQUESTED",
		infoRequested:"INFO_REQUESTED",
	}

	return (
		<>
			{itemStatus === status.approve &&  <Tags label={text} tagClassName='DS__tag--success'/>}
			{itemStatus === status.reject && <Tags label={text} tagClassName='DS__tag--critical'/>}
			{(itemStatus === status.pending || itemStatus === status.pendingApproval) && <Tags label={text} tagClassName='DS__tag--warning'/>}
			{(itemStatus === status.dsaRequested || itemStatus === status.infoRequested || itemStatus === status.signDsa || itemStatus === status.requestForInfo ) && <Tags label={text} tagClassName='status-label'/>}
		</>
	)
}

export default StatusLabel
